import * as React from "react";
import cn from "classnames";
import { KEY_CODES } from "../KeypressHandler/KeypressHandler";
import Styles from "./Clickable.module.scss";

export interface Sides {
  top?: number;
  bottom?: number;
  left?: number;
  right?: number;
}
interface Props {
  onClick: (event: React.SyntheticEvent) => void;
  children: any;
  className?: string;
  centerContent?: boolean;
  isPressed?: boolean;
  padding?: Sides;
  role?: "button" | "option";
  ["data-testid"]?: string;
}

export const Clickable = ({
  onClick,
  centerContent,
  children,
  className,
  isPressed,
  role = "button",
  padding,
}: Props) => {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.keyCode === KEY_CODES.ENTER || event.keyCode === KEY_CODES.SPACE) {
      onClick(event);
    }
  };

  return (
    <span
      onClick={onClick}
      onKeyDown={handleKeyDown}
      className={cn(Styles.container, className, {
        [Styles.centerContent]: centerContent,
      })}
      role={role}
      {...{ [role === "button" ? "aria-pressed" : "aria-selected"]: isPressed }}
      tabIndex={0}
      style={
        padding
          ? {
              paddingTop: `${padding.top}px`,
              paddingLeft: `${padding.left}px`,
              paddingBottom: `${padding.bottom}px`,
              paddingRight: `${padding.right}px`,
            }
          : {}
      }
    >
      {children}
    </span>
  );
};
